import { render, staticRenderFns } from "./FixOrderItemTable.vue?vue&type=template&id=493b094c&scoped=true&"
import script from "./FixOrderItemTable.vue?vue&type=script&lang=ts&"
export * from "./FixOrderItemTable.vue?vue&type=script&lang=ts&"
import style0 from "./FixOrderItemTable.vue?vue&type=style&index=0&id=493b094c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "493b094c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VSimpleTable})
